// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateFormVisibility = (state, action) => action.isFormVisible;

export default (state = getDefaultState().isFormVisible, action) => {

    const actionTypes = {
        [actions.UPDATE_PIP_CODE_FORM_VISIBILITY]: updateFormVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/pip/pip-code/reducers/form-visibility.js